 
const config = {
  api: 'https://foodsafetyint.com/app/public/api',
  clientLogo: 'https://foodsafetyint.com/app/public/documents/',
  logos: 'https://foodsafetyint.com/app/public/logos/',
  urlDocuments: 'https://foodsafetyint.com/app/public/',
};

const configLocal = {
  api: 'http://localhost:8000/api',
  clientLogo: 'http://localhost:8000/documents/',
  logos: 'http://localhost:8000/logos/',
  urlDocuments: 'http://localhost:8000/'
};

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

module.exports = ( isLocalhost ? configLocal : config);
